import createSelector from "../../utils/reselect";

const communicationsStateData = (state) => {
  const { communications } = state;
  return communications || {};
};

export const getError = createSelector(communicationsStateData, (projects) =>
  projects.get("error")
);

export const communicationPlanStatusLoading = createSelector(
  communicationsStateData,
  (communications) => communications.get("communicationPlanStatusLoading")
);

export const communicationPlans = createSelector(
  communicationsStateData,
  (communications) => communications.get("communicationPlans")
);

export const communicationPagination = createSelector(
  communicationsStateData,
  (communications) => communications.get("communicationPagination")
);

export const communicationPlansLoading = createSelector(
  communicationsStateData,
  (communications) => communications.get("pageLoading")
);
